export const namespaced = true

const initialState = {
  notifications: []
}
export const state = {
  notifications: []
}
let nextId = 1
export const mutations = {
  PUSH(state, notification) {
    state.notifications.push({
      ...notification,
      id: nextId++
    })
  },
  DELETE(state, notificationToRemove) {
    state.notifications = state.notifications.filter(
      n => n.id !== notificationToRemove.id
    )
  },
  CLEAR_ALL(state) {
    state.notifications = []
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  add({ commit }, notification) {
    commit('PUSH', notification)
  },
  remove({ commit }, notificationToRemove) {
    commit('DELETE', notificationToRemove)
  },
  clearAll({ commit }) {
    commit('CLEAR_ALL')
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}
